import script from "./QRTemplateOne.vue?vue&type=script&lang=ts&setup=true"
export * from "./QRTemplateOne.vue?vue&type=script&lang=ts&setup=true"

import "./QRTemplateOne.vue?vue&type=style&index=0&id=6e51127d&lang=css"
/* custom blocks */
import block0 from "./QRTemplateOne.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__